import axios from 'axios';
import RestService from '../../../../../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function setLabelKey(key, data) {
  return async (dispatch) => {
    dispatch({type: "SET_KEY_LABEL", key, data})
  }
}

export function getLabels() {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_LABEL_KEY', key: 'loaded', data: false})
      const {data} = await axios.get('/api/labels/get');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_LABELS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_LABELS', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export async function changeLabelQuestion(body) {
  try {
    const {data} = await axios.post('/api/labels/question', {
      ...body,
    });
    return true;
  } catch (error) {
    return Promise.reject({message: 'Bag request'})      
  }
}

export function createLabel(body) {
  return async (dispatch,) => {
    try {
      dispatch({type: 'SET_LABEL_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/labels/post', {
        ...body,
      });
      if(data.errcode == 200) {
        dispatch({type: 'ADD_LABEL', data: data.payload})
        return payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}


export function deleteLabel(id) {
  return async (dispatch) => {
    try {
     
      const {data} = await axios.post('/api/labels/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_LABEL', data: id});
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateLabel(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/labels/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
       
        dispatch({type: 'UPDATE_LABEL', data: payload});
        
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/actions.js